export const FLEX_WRAP_CLASSES = {
    wrap: 'flex-wrap',
    'wrap-reverse': 'flex-wrap-reverse',
    nowrap: 'flex-nowrap',
};
export const applyFlexWrap = (flexWrap) => [...(flexWrap ? [FLEX_WRAP_CLASSES[flexWrap]] : [])];
